module.exports = __webpack_public_path__ + "img/1.39db5aa7.png";